<ion-row>
  <!-- Stop Type -->
  <ion-col size="4">
    <div class="property-header">{{ CONSTANTS.STOP_TYPE }}</div>
    <div>
      @if (data[0].type === STOP_TYPES.PS) {
        <div class="stop-type-icons">
          <img [src]="SRC.PICKUP" alt="stop type" />
          {{ CONSTANTS.PICKUP }}
        </div>
      }
      @if (data[0].type === STOP_TYPES.DS) {
        <div class="stop-type-icons">
          <img [src]="SRC.DELIVERY" alt="stop type" />
          {{ CONSTANTS.DELIVERY }}
        </div>
      }
    </div>
  </ion-col>

  <!-- Stop Number -->
  <ion-col size="4">
    <div class="property-header">
      {{ CONSTANTS.STOP_NUMBER }}
    </div>
    <div>{{ viewIndex || data[0].index + 1 }}</div>
  </ion-col>

  <!-- Consignee -->
  <ion-col size="4" class="property-container">
    <div class="property-header">{{ CONSTANTS.CONSIGNEE }}</div>
    <div>{{ data[0].cosignee }}</div>
  </ion-col>
</ion-row>

<ion-row>
  <!-- Street Address -->
  <ion-col size="5">
    <div class="property-header">{{ CONSTANTS.STREET_ADDRESS }}</div>
    <div>{{ data[0].address }}</div>
  </ion-col>

  <!-- City -->
  <ion-col size="4">
    <div class="property-header">{{ CONSTANTS.CITY }}</div>
    <div>{{ data[0].city }}</div>
  </ion-col>

  <!-- Postal -->
  <ion-col size="3">
    <div class="property-header">{{ CONSTANTS.POSTAL }}</div>
    <div>{{ data[0].postal }}</div>
  </ion-col>
</ion-row>
